import { browserHistory } from "react-router";
import shop from "../api/shop";
import {
  COMMON_STORE,
  COMMON_CHANGE_SHIPPING,
  COMMON_CHANGE_PAYMENT,
  COMMON_SET_SHIPPING_PRICE,
  COMMON_OPEN_MODAL,
  COMMON_CLOSE_MODAL,
  CATEGORY_TOGGLE,
  HEADER_CART,
  LOADING,
  SEARCH_LOADING,
  FILTER_TOGGLE,
  LOGIN_TOGGLE,
  LOST_PASS_TOGGLE,
  LOGIN_USER,
  LOGOUT_USER,
  INPUT_MESSAGE,
  INPUT_STATUS,
  PROFILE_CHANGED,
  SET_USER_PROFILE,
  SET_ALERT_NOTIFICATION,
  ADD_OFFSET,
  COUNTRIES_STORE,
  LOGIN_OZ,
  SET_SELECTED_USER,
  STORE_TOKEN,
  CLEAR_CUSOMER_DATA,
  MEC_STORE,
  LOADING_LOGIN,
  LOADING_COMMON,
  TOGGLE_LOGIN_MODAL,
  STORE_FAILURED_API_CALLS,
  HEADER_MOBILE_SEARCH_BAR,
  TOGGLE_SIDEBAR_CATEGORY,
  SET_LOADING_PROGRESS,
  LOGIN_ADMIN,
  LOADING_SALESMEN,
  STORE_SALESMEN,
  RESET_STATE,
  TOGGLE_ORDER_TYPE_DROPDOWN,
  OPEN_ORDERS_LOADING,
  OPEN_ORDERS_STORE,
  STORE_ERROR,
  SET_OPENED_ORDER,
  DISABLE_OPENED_ORDER,
  DELETE_CART_PRODUCT,
  LOADING_SALES,
  STORE_SALES,
  SHOWING_HOT_PRODUCTS,
  USE_CREDIT,
  TOGGLE_CUSTOMER_DETAIL,
  PRODUCT_STORE
} from "./actionTypes";
import { commonState } from "./stateModel";
import { setActiveLanguage } from "react-localize-redux";
import { history } from "../components/App";

// ------------------------------------
// Actions
// ------------------------------------

const loadingSalesUnsafe = loading => ({
  type: LOADING_SALES,
  loading
});

export const loadingSales = (state = null) => (dispatch, getState) => {
  if (state) {
    dispatch(loadingSalesUnsafe(state));
  } else {
    dispatch(loadingSalesUnsafe(!getState().common.salesLoading));
  }
};

const storeSalesUnsafe = sales => ({
  type: STORE_SALES,
  sales
});

export const storeSales = sales => dispatch => {
  dispatch(storeSalesUnsafe(sales));
};

const showHotsUnsafe = state => ({
  type: SHOWING_HOT_PRODUCTS,
  state
});

export const showHots = (state = null) => (dispatch, getState) => {
  if (state !== null) {
    dispatch(showHotsUnsafe(state));
  } else {
    dispatch(showHotsUnsafe(!getState().common.showingHotsProducts));
  }
};

export const resetState = () => ({
  type: RESET_STATE
});

export const storeError = error => ({
  type: STORE_ERROR,
  error
});

export const toggleLoginModal = status => ({
  type: TOGGLE_LOGIN_MODAL,
  status
});

export const storeFailedAPIcalls = (url, body, method) => ({
  type: STORE_FAILURED_API_CALLS,
  url,
  body,
  method
});

const loadingUnsafe = loading => ({
  type: LOADING,
  loading
});

export const loading = (state = null) => (dispatch, getState) => {
  if (state) {
    dispatch(loadingUnsafe(state));
  } else {
    dispatch(loadingUnsafe(!getState().common.loading));
  }
};

const receiveData = data => ({
  type: COMMON_STORE,
  data
});

const loadingCommon = status => ({
  type: LOADING_COMMON,
  status
});

export const storeCommonData = () => dispatch => {
  dispatch(loadingCommon(true));
  shop.getMeCommon(dataFromApi => {
    dataFromApi.then(data => {
      data["token"] = localStorage.getItem("token");
      dispatch(receiveData(data));
      dispatch(loadingCommon(false));
      if (data.language) {
        dispatch(setActiveLanguage(data.language));
      }
    });
  });
};

export const loadingSalesmen = status => ({
  type: LOADING_SALESMEN,
  status
});

const storeSalesmenUnsafe = salesmen => ({
  type: STORE_SALESMEN,
  salesmen
});

export const storeSalesmen = salesmen => dispatch => {
  dispatch(storeSalesmenUnsafe(salesmen));
};

export const setOZ = oz => dispatch => {
  dispatch(loadingSalesmen(true));
  shop.getOzMe(oz.id, dataFromApi => {
    dataFromApi.then(data => {
      localStorage.setItem("token", data.access_token);
      data["token"] = data.access_token;
      dispatch(receiveData(data));
      dispatch(loadingSalesmen(false));
      history.push("/");
    });
  });
};

export const storeToken = token => ({
  type: STORE_TOKEN,
  token
});

const receiveCountries = countries => ({
  type: COUNTRIES_STORE,
  countries
});

export const storeCountries = countries => dispatch => {
  dispatch(receiveCountries(countries));
};

const changeShippingMethodUnsafe = shippingId => ({
  type: COMMON_CHANGE_SHIPPING,
  shippingId
});

export const changeShippingMethod = shippingId => (dispatch, getState) => {
  dispatch(changeShippingMethodUnsafe(shippingId));
  const userPayment = getState().common.user.payment;
  const price = userPayment
    ? getState()
      .common.shipping.find(ship => ship.company.id === shippingId)
      .payment.find(payment => payment.id === userPayment).value
    : 0;
  if (price) {
    dispatch(setShippingPriceUnsafe(price));
  }
};

const changePaymentMethodUnsafe = paymentId => ({
  type: COMMON_CHANGE_PAYMENT,
  paymentId
});

export const changePaymentMethod = paymentId => (dispatch, getState) => {
  dispatch(changePaymentMethodUnsafe(paymentId));
};

const setShippingPriceUnsafe = price => ({
  type: COMMON_SET_SHIPPING_PRICE,
  price
});

export const toggleModal = (modal, open) => dispatch => {
  open ? dispatch(openModalUnsafe(modal)) : dispatch(closeModalUnsafe(modal));
};

const closeModalUnsafe = modal => ({
  type: COMMON_CLOSE_MODAL,
  modal
});
const openModalUnsafe = modal => ({
  type: COMMON_OPEN_MODAL,
  modal
});

const toggleCartUnsafe = cartOpen => ({
  type: HEADER_CART,
  cartOpen
});

export const toggleCart = (state = null) => (dispatch, getState) => {
  if (state !== null) {
    dispatch(toggleCartUnsafe(state));
  } else {
    dispatch(toggleCartUnsafe(!getState().common.cartOpen));
  }
};
const toggleMobileSearchBarUnsafe = status => ({
  type: HEADER_MOBILE_SEARCH_BAR,
  status
});

export const toggleMobileSearchBar = () => (dispatch, getState) => {
  dispatch(toggleMobileSearchBarUnsafe(!getState().common.mobileSearchBarOpen));
};

const filterToggleUnsafe = filterOpen => ({
  type: FILTER_TOGGLE,
  filterOpen
});

export const filterToggle = () => (dispatch, getState) => {
  dispatch(filterToggleUnsafe(!getState().common.filterOpen));
};

const toggleLoginFormUnsafe = loginOpen => ({
  type: LOGIN_TOGGLE,
  loginOpen
});

export const toggleLoginForm = () => (dispatch, getState) => {
  dispatch(toggleLoginFormUnsafe(!getState().common.loginOpen));
};

const toggleLostSignInLinkUnsafe = lostPassOpen => ({
  type: LOST_PASS_TOGGLE,
  lostPassOpen
});

export const toggleLostSignInLink = () => (dispatch, getState) => {
  dispatch(toggleLostSignInLinkUnsafe(!getState().common.lostPassOpen));
};

const loginOzUnsafe = data => ({
  type: LOGIN_OZ,
  data
});

const loginAdminUnsafe = data => ({
  type: LOGIN_ADMIN,
  data
});

export const submitLogin = (email, password) => (dispatch, getState) => {
  // const data = {
  //   company: {},
  //   shipping: {},
  //   user: {currency: {sign: '$'}},
  //   token: 'token',
  // };
  // dispatch (loginUserUnsafe (data));
  dispatch(loadingUnsafe(true));
  // var formData = new FormData ();
  // formData.append ('login', email);
  // formData.append ('password', password);
  shop.getCommon(
    { login: email, password: password },
    commonDataFromApi => {
      commonDataFromApi.then(data => {
        if (data.error) {
          alert("Error: " + data.message);
          dispatch(loadingUnsafe(false));
          return false;
        } else {
          if (data.language ? data.language : false) {
            dispatch(setActiveLanguage(data.language));
          }

          if (data.oz.id_role > 3) {
            dispatch(loginAdminUnsafe(data));
            history.push("/salesmen");
          } else {
            dispatch(loginOzUnsafe(data));
          }

          localStorage.setItem("token", data.access_token);

          const { failuredApiCalls } = getState().common;
          if (failuredApiCalls.length > 0) {
            failuredApiCalls.map(call => {
              console.log("need recall " + call.url);
            });
          }

          shop.getMEC(meDataFromApi => {
            meDataFromApi.then(me => {
              dispatch(storeMEC(me));
            });
          });
        }
      });
    },
    0
  );
};

export const getMEC = () => dispatch => {
  shop.getMEC(meDataFromApi => {
    meDataFromApi.then(me => {
      dispatch(storeMEC(me));
    });
  });
};

const storeMEC = ({
  edition,
  manufacturer,
  compatibility,
  color,
  orderTypes,
  flexColors,
  hotProductsCount,
  dailyHotProducts,
  tags,
}) => ({
  type: MEC_STORE,
  edition,
  manufacturer,
  compatibility,
  color,
  orderTypes,
  flexColors,
  hotProductsCount,
  dailyHotProducts,
  tags,
});

/**
 *
 *
 * functions to recall endpoints after login
 *
 *
 */

export const resetPass = email => (dispatch, getState) => {
  console.log("reset");
};

const logoutUserUnsafe = () => ({
  type: LOGOUT_USER
});

export const logout = (stay = false) => dispatch => {
  dispatch(logoutUserUnsafe());
  dispatch(setActiveLanguage("gb"));
  localStorage.removeItem("token");
  localStorage.removeItem("state");
  if (!stay) {
    browserHistory.push("/");
    browserHistory.go();
  }
};

export const loginLoading = status => ({
  type: LOADING_LOGIN,
  status
});

const setInputMsgUnsafe = (msg, input) => ({
  type: INPUT_MESSAGE,
  msg,
  input
});

export const setInputMsg = (msgCode, inputName) => dispatch => {
  dispatch(setInputMsgUnsafe(msgCode, inputName));
};

const setInputStatusUnsafe = (status, input) => ({
  type: INPUT_STATUS,
  status,
  input
});

export const setInputStatus = (status, inputName) => dispatch => {
  dispatch(setInputStatusUnsafe(status, inputName));
  if (status === true) {
    dispatch(setInputMsgUnsafe(null, inputName));
  }
};

const setProfileChanged = status => ({
  type: PROFILE_CHANGED,
  status
});

export const setProfileChangedByAction = state => dispatch => {
  dispatch(setProfileChanged(state));
};

const setUserProfileUnsafe = profile => ({
  type: SET_USER_PROFILE,
  profile
});

export const setUserProfile = (name, value, section) => dispatch => {
  dispatch(setProfileChanged(true));
  dispatch(
    setUserProfileUnsafe({ name: name, value: value, section: section })
  );
};

const setAlertNotificationUnsafe = notification => ({
  type: SET_ALERT_NOTIFICATION,
  notification
});

export const setAlertNotification = (message, type) => dispatch => {
  let notification = null;
  if (message) {
    notification = [{ message: message, type: type || "info" }];
    setTimeout(() => dispatch(setAlertNotificationUnsafe(null)), 5000);
  }
  dispatch(setAlertNotificationUnsafe(notification));
};

const addOffsetUnsafe = step => ({
  type: ADD_OFFSET,
  step
});

export const addOffset = () => (dispatch, getState) => {
  let step = getState().common.offset;
  dispatch(addOffsetUnsafe(++step));
};

export const resetOffset = () => dispatch => {
  dispatch(addOffsetUnsafe(1));
};

const toggleCategorySidebarUnsafe = status => ({
  type: TOGGLE_SIDEBAR_CATEGORY,
  status
});

export const toggleCategorySidebar = status => dispatch => {
  dispatch(toggleCategorySidebarUnsafe(status));
};
const toggleOrderTypeDropdownUnsafe = status => ({
  type: TOGGLE_ORDER_TYPE_DROPDOWN,
  status
});

export const toggleOrderTypeDropdown = () => (dispatch, getState) => {
  dispatch(
    toggleOrderTypeDropdownUnsafe(!getState().common.orderTypeDropdownOpen)
  );
};

export const submitOpenedOrders = id => dispatch => {
  dispatch(toggleModal("submit_opened_order_modal", true));
  dispatch(loadingOpenOrders(true));
  shop.getSummaryOpenedOrder(id, cartFromApi => {
    cartFromApi.then(cartItems => {
      dispatch(
        storeOpenOrders(
          cartItems["openedOrdersSummary"],
          cartItems["notAvailable"]
        )
      );
      dispatch(loadingOpenOrders(false));
    });
  });
};

export const storeOpenOrders = (orders, unavailableItems) => ({
  type: OPEN_ORDERS_STORE,
  orders,
  unavailableItems
});

export const loadingOpenOrders = status => ({
  type: OPEN_ORDERS_LOADING,
  status
});

const setLoadingStepUnsafe = progress => ({
  type: SET_LOADING_PROGRESS,
  progress
});

export const setLoadingStep = (val = null) => (dispatch, getState) => {
  if (val === 0) {
    dispatch(setLoadingStepUnsafe(parseInt(val)));
  } else {
    const progressVal =
      Number(Math.floor(Math.random() * 10) + 1) +
      Number(getState().common.progressStep);
    dispatch(setLoadingStepUnsafe(progressVal));
  }
};

export const useCredit = credit => ({
  type: USE_CREDIT,
  credit
});


const toggleCustomerDetailUnsafe = showing => ({
  type: TOGGLE_CUSTOMER_DETAIL,
  showing
});

export const toggleCustomerDetail = (value = null) => (dispatch, getState) => {
  if (value !== null) {
    dispatch(toggleCustomerDetailUnsafe(value));
  } else {
    dispatch(toggleCustomerDetailUnsafe(!getState().common.customerDetail));
  }
};


export const isCartOpened = state => state || false;
export const isLoading = state => state || false;
export const isSearchLoading = state => state || false;
export const isFilterOpen = state => state || false;
export const getShipping = state => state || [];
export const getUserShipping = state => state || 0;
export const getUserPayment = state => state || 0;
export const getPayment = (state, shippingId) => {
  if (!state) return 0;
  let paymentList = state.find(ship => ship.company.id === shippingId);

  if (!paymentList) return 0;
  return paymentList.payment;
};

export const getModalStatus = state => state || false;
export const getShippingPrice = state => state || null;
export const getUserData = state => state || {};
export const getCompanyData = state => state || null;
export const getFilterByType = (state, type) =>
  state[type] ? state[type] : undefined;
export const getFilter = (state, type) => {
  if (!state) return "";
  const f = state.find(f => f.type === type);
  return f ? f.value : "";
};
export const getSortByStatus = state => state || null;
export const getSortOrderStatus = state => state || null;
export const getLobingState = state => state || false;
export const getCurrentPathname = state => state || "/";
export const isLoginOpen = state => state || false;
export const isLostPassOpen = state => state || false;
export const isProfileChanged = state => state || false;
export const isUserLoggedIn = state => !!(state && state !== "null");
export const getUserName = state =>
  state && state.personal
    ? state.personal.first_name + " " + state.personal.last_name
    : null;
export const getInputStatus = (state, input) =>
  state
    ? state.find(i => i.name === input)
      ? state.find(i => i.name === input).status
      : null
    : null;
export const getInputMsg = (state, input) =>
  state
    ? state.find(i => i.name === input)
      ? state.find(i => i.name === input).messages
      : []
    : [];
export const getFormInputsStatus = (state, inputArr) => {
  let is = [];
  if (state) {
    inputArr.map(ia =>
      state.find(i => i.name === ia)
        ? is.push(state.find(i => i.name === ia).status)
        : is.push(null)
    );
  }
  return is.every(e => e);
};
export const getAlertNotification = state => (state ? state[0] : null);
// export const getCurrencySign = state => state || "€";
export const getCurrencySign = state => "€";

// ------------------------------------
// Reducer
// ------------------------------------
// const initialState = [];
export default function commonReducer(state = commonState, action) {
  switch (action.type) {
    case COMMON_STORE:
      return {
        ...state,
        oz: action.data.oz,
        token: action.data.token
      };
    case COMMON_CHANGE_SHIPPING:
      const userShipping = Object.assign({}, state.user);
      userShipping.shipping = action.shippingId;
      return {
        ...state,
        user: userShipping
      };
    case COMMON_CHANGE_PAYMENT:
      const userPayment = Object.assign({}, state.user);
      userPayment.payment = action.paymentId;
      return {
        ...state,
        user: userPayment
      };
    case COMMON_SET_SHIPPING_PRICE:
      const userData = Object.assign({}, state.user);
      userData.shippingCost = action.price;
      return {
        ...state,
        user: userData
      };
    case COMMON_OPEN_MODAL:
      let modalsToOpen = Object.assign({}, state.modals);
      // if(!modalsToOpen[action.modal]){
      //   modalsToOpen[action.modal]=true;
      // }else{
      modalsToOpen[action.modal] = true;
      // }
      return {
        ...state,
        modals: modalsToOpen
      };
    case COMMON_CLOSE_MODAL:
      // let modalsToClose = Object.assign([], state.modals);
      // if(modalsToClose.length ===0 || modalsToClose.findIndex(m => m.name === action.modal) !== -1){
      //   modalsToClose.push({name:action.modal,show:false});
      // }else{
      //   modalsToClose.find(m => m.name === action.modal).show = false;
      // }
      let modalsToClose = Object.assign({}, state.modals);
      modalsToClose[action.modal] = false;
      return {
        ...state,
        modals: modalsToClose
      };

    case CATEGORY_TOGGLE:
      return {
        ...state,
        loading: action.loading
      };
    case HEADER_CART:
      return {
        ...state,
        cartOpen: action.cartOpen
      };
    case FILTER_TOGGLE:
      return {
        ...state,
        filterOpen: action.filterOpen
      };
    case LOADING:
      return {
        ...state,
        loading: action.loading
      };
    case SEARCH_LOADING:
      return {
        ...state,
        searchLoading: action.loading
      };
    case LOGIN_TOGGLE:
      return {
        ...state,
        loginOpen: action.loginOpen
      };
    case LOST_PASS_TOGGLE:
      return {
        ...state,
        lostPassOpen: action.lostPassOpen
      };
    case LOGIN_USER:
      return {
        ...state,
        company: action.data.company,
        shipping: action.data.shipping,
        user: action.data.user
      };
    case LOGOUT_USER:
      const countries = Object.assign([], state.countries);
      return { ...commonState, countries: countries };
    case LOGIN_OZ:
      return {
        ...state,
        oz: action.data.oz,
        token: action.data.access_token,
        isLoginModalOpen: false
      };
    case LOGIN_ADMIN:
      return {
        ...state,
        isAdmin: true,
        token: action.data.access_token,
        adminToken: action.data.access_token,
        isLoginModalOpen: false
      };
    case INPUT_STATUS:
      let inputStatus = Object.assign([], state.input);
      let isi = inputStatus.findIndex(i => i.name === action.input);
      if (isi === -1) {
        inputStatus.push({
          name: action.input,
          messages: [],
          status: action.status
        });
      } else {
        inputStatus[isi].status = action.status;
      }
      return {
        ...state,
        input: inputStatus
      };
    case INPUT_MESSAGE:
      let inputMsg = Object.assign([], state.input);
      let imi = inputMsg.findIndex(i => i.name === action.input);
      if (imi === -1) {
        inputMsg.push({
          name: action.input,
          messages: [action.msg],
          status: false
        });
      } else if (action.msg === null) {
        inputMsg[imi].messages = [];
      } else if (
        inputMsg[imi].messages.findIndex(m => m === action.msg) === -1
      ) {
        inputMsg[imi].messages.push(action.msg);
      }
      return {
        ...state,
        input: inputMsg
      };
    case PROFILE_CHANGED:
      return {
        ...state,
        profileIsChanged: action.status
      };
    case SET_USER_PROFILE:
      let profile = Object.assign({}, state.user);
      profile[action.profile.section][action.profile.name] =
        action.profile.value;
      return {
        ...state,
        user: profile
      };
    case SET_ALERT_NOTIFICATION:
      return {
        ...state,
        notifications: action.notification ? action.notification : []
      };
    case ADD_OFFSET:
      return {
        ...state,
        offset: action.step
      };
    case COUNTRIES_STORE:
      return {
        ...state,
        countries: action.countries
      };
    case SET_SELECTED_USER:
      return { ...state, user: action.customer };
    case STORE_TOKEN:
      return { ...state, token: action.token };
    case CLEAR_CUSOMER_DATA:
      return { ...state, user: commonState.user, cartOpen: false };
    case PRODUCT_STORE: {
      const compatibilityListFull = [];
			action.products.map(p => {
				if (p.compatibility.includes(',')) {
					p.compatibility.split(',').map(c => {
						compatibilityListFull.push(c);
					});
				} else {
					compatibilityListFull.push(p.compatibility);
				}
				return p.compatibility;
			})
			const compatibilityList = [...new Set(compatibilityListFull.sort())].filter(v=>v).map(v => ({
					value: v,
					label: v,
				}));
			return { ...state, compatibility: compatibilityList }
    }
    case MEC_STORE:
      // const compatibilityList = action.compatibility.map(c => ({
      //   value: c.name.trim(),
      //   label: c.name
      // }));
      const manufacturerList = action.manufacturer.map(c => ({
        value: c.id,
        label: c.name
      }));
      const editionList = action.edition.map(c => ({
        value: c.id,
        label: c.name
      }));
      const orderTypesList = action.orderTypes.map(ot => ({
        value: ot.id,
        label: ot.type
      }));
      const flexColorsList = action.flexColors.map(fc => ({
        value: fc.flex_color,
        label: fc.flex_color
      }));
      const tagList = action.tags.reduce((a, v) => ({ ...a, [v.id]: v }), {})
      return {
        ...state,
        manufacturer: manufacturerList,
        edition: editionList,
        compatibility: [],
        color: action.color,
        tags: tagList,
        orderTypes: orderTypesList,
        flexColors: flexColorsList,
        isAnyHotProducts: action.hotProductsCount > 0,
        dailyHotProducts: action.dailyHotProducts
      };
    case LOADING_LOGIN:
      return { ...state, loginLoading: action.status };
    case LOADING_COMMON:
      return { ...state, commonLoading: action.status };
    case TOGGLE_LOGIN_MODAL:
      return { ...state, isLoginModalOpen: action.status };
    case STORE_ERROR:
      return { ...state, error: action.error };
    case STORE_FAILURED_API_CALLS:
      return {
        ...state,
        failuredApiCalls: {
          url: action.url,
          body: action.body,
          method: action.method
        }
      };
    case HEADER_MOBILE_SEARCH_BAR:
      return { ...state, mobileSearchBarOpen: action.status };
    case TOGGLE_SIDEBAR_CATEGORY:
      return { ...state, categorySidebarOpen: action.status };
    case SET_LOADING_PROGRESS:
      return { ...state, progressStep: action.progress };
    case LOADING_SALESMEN:
      return { ...state, salesmenLoading: action.status };
    case STORE_SALESMEN:
      return { ...state, salesmen: action.salesmen };
    case RESET_STATE:
      return { ...state, salesmen: [] };
    case TOGGLE_ORDER_TYPE_DROPDOWN:
      return { ...state, orderTypeDropdownOpen: action.status };
    case OPEN_ORDERS_LOADING:
      return { ...state, openOrdersLoading: action.status };
    case OPEN_ORDERS_STORE:
      return {
        ...state,
        openOrdersList: action.orders,
        unavailableItems: action.unavailableItems
      };
    case DELETE_CART_PRODUCT:
      return {
        ...state,
        unavailableItems: state.unavailableItems.filter(
          uai => Number(uai.id_product) !== Number(action.productId)
        )
      };
    case SET_OPENED_ORDER:
      return {
        ...state,
        user: {
          ...state.user,
          orderType: {
            ...state.user.orderType,
            [action.orderType]: "oz"
          }
        }
      };
    case DISABLE_OPENED_ORDER:
      const oo = Object.assign({}, state.user.orderType);
      Object.keys(oo).map(key => {
        oo[key] = oo[key] === "oz" ? null : oo[key];
      });
      return {
        ...state,
        user: {
          ...state.user,
          orderType: oo
        }
      };
    case STORE_SALES:
      return { ...state, sales: action.sales };
    case LOADING_SALES:
      return { ...state, salesLoading: action.loading };
    case SHOWING_HOT_PRODUCTS:
      return {
        ...state,
        showingHotsProducts: action.state,
        dailyHotProducts: 0
      };
    case USE_CREDIT: {
      const userCredit = state.user.credit;
      return {
        ...state,
        user: {
          ...state.user,
          credit: userCredit - action.credit
        }
      }
    };
    case TOGGLE_CUSTOMER_DETAIL:
      return {
        ...state,
        customerDetail: action.showing
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/common.js